import React, { useMemo } from "react";
import { Box, Text } from "@chakra-ui/react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { normalizeOrganizationTicketChartData } from "./organizationTicketOutcomeChartData";

const OrganizationTicketsOutcomeChart = React.memo(({ title, chart, chartHeight }) => {
  const chartData = useMemo(() => normalizeOrganizationTicketChartData(chart), [chart]);
  const height = chartHeight ? parseInt(chartHeight, 10) : 320;

  return (
    <Box width="100%">
      {title ? (
        <Text textAlign="center" color="gray.600" fontSize="13px" mb={2}>
          {title}
        </Text>
      ) : null}
      <ResponsiveContainer width="100%" height={height} debounce={300}>
        <ComposedChart
          data={chartData}
          margin={{
            top: 8,
            right: 12,
            left: -8,
            bottom: 18,
          }}
        >
          <CartesianGrid stroke="#ebebeb" vertical={false} />
          <XAxis
            dataKey="day"
            name="Day"
            axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            tick={{ fontSize: 12 }}
          />
          <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend width="100%" />
          <Bar dataKey="completed" name="Completed" stackId="ticket-outcome" fill="var(--green)" />
          <Bar dataKey="noShow" name="No Show" stackId="ticket-outcome" fill="var(--red)" />
          <Bar
            dataKey="unattended"
            name="Unattended"
            stackId="ticket-outcome"
            fill="var(--orange)"
          />
          <Line
            type="linear"
            strokeWidth={1.8}
            dataKey="total"
            name="Total Tickets"
            stroke="var(--blue)"
            dot={{ fill: "var(--blue)", r: 2 }}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
});

export default OrganizationTicketsOutcomeChart;
